import React, { createContext, useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Modal from '../components/shared/Modal';
import Button from '../components/shared/Button';

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);
    const [errorModal, setErrorModal] = useState(null);

    const addToast = useCallback((message, type = 'info', duration = 4000) => {
        const id = uuidv4();
        setToasts(prev => [...prev, { id, message, type }]);

        if (duration) {
            setTimeout(() => {
                removeToast(id);
            }, duration);
        }
    }, []);

    const removeToast = useCallback((id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    }, []);

    const success = (msg, duration) => addToast(msg, 'success', duration);

    // ERROR: Show Modal instead of Toast
    const error = (msg) => {
        setErrorModal(msg);
        // Optional: Log to console or still show toast? 
        // User requested "Pop up şeklinde ver", implying replacement.
        // We will NOT show toast for error to avoid duplication.
    };

    const info = (msg, duration) => addToast(msg, 'info', duration);
    const warning = (msg, duration) => addToast(msg, 'warning', duration);

    return (
        <ToastContext.Provider value={{ toasts, addToast, removeToast, success, error, info, warning }}>
            {children}

            {/* Global Error Modal */}
            {errorModal && (
                <Modal
                    isOpen={!!errorModal}
                    onClose={() => setErrorModal(null)}
                    title="⚠️ Hata"
                    size="sm"
                    footer={
                        <div className="flex justify-end w-full">
                            <Button variant="secondary" onClick={() => setErrorModal(null)}>Kapat</Button>
                        </div>
                    }
                >
                    <div className="p-md text-center">
                        <div style={{ fontSize: '3rem', marginBottom: '16px' }}>❌</div>
                        <p className="text-lg font-medium">{errorModal}</p>
                    </div>
                </Modal>
            )}
        </ToastContext.Provider>
    );
};
